import React, { useState } from 'react'
// import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import { Form, Input, Button, Alert } from 'antd';
import axios from 'axios';
import { useNavigate } from "react-router-dom"

function Login() {
  const [errorMessage, setErrorMessage] = useState("")
  const [showError, setShowError] = useState(false)


  // const disableBack = () => { window.history.forward(); }
  // setTimeout(disableBack(), 0);
  // window.onunload = function () { null };

//   useEffect(() => {
//   setTimeout(() => {
//     window.history.forward()
//   }, 0);
// window.onunload = (() => { null });
//   }, [])



  const onFinish = (values) => {


    var today = new Date();
    // var hours=today.getHours()
    // var minut=today.getMinutes()
    var time = today.getHours() + ":" + today.getMinutes();
    if (time === "14:20") {
      console.log("hello")
    }
    console.log("++ time +++", time)
    console.log("+++ val ++++", values)
    axios.get("http://localhost:9090/studentlogin").then(res => {
      console.log("++++ login ++++", res)
     if (res.data.data[0].email === values.username && res.data.data[0].pass === values.password) {
        navigate("/employeedetails")

      }
      else {
        setShowError(true)
        setErrorMessage("Entrypasskey or password is wrong")

        // alert("kar di na galti")
      }
    }).catch(err => {
      console.log("++++++ login err ++++=", err)
    })


    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const navigate = useNavigate()


  return (
    <>
      <div style={{ height: "70px", width: "70%", margin: "70px auto" }}>
        {
          showError ? <Alert message={errorMessage} type="error" showIcon /> : ""
        }
      </div>



      <div style={{
        margin: "100px",
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Entrypasskey"
            name="username"
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          {/* <Form.Item
        name="remember"
        valuePropName="checked"
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
        <Checkbox>Remember me</Checkbox>
      </Form.Item> */}

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>

    </>
  )
}

export default Login
